import EmployeesVacatiions from './employees_vacations/EmployeesVacations';
import Calendar from './calendar/Calendar';
import EmployeesTimeLines from './employees_time_lines/EmployeesTimeLines';
import VacationRequest from './employee_vacation_request/vacationRequest';
import RequestsTimeLines from './vacation_requests_approval/vacationRequestsTimeLines';
const router = [
  {
    type: 'private',
    path: '/saldo-vacaciones',
    roles: ['administrador', 'jefe'],
    component: EmployeesVacatiions,
    exact: true,
  },
  {
    type: 'private',
    path: '/planificador-vacaciones/:username',
    roles: ['administrador', 'jefe'],
    component: Calendar,
    exact: true,
  },
  {
    type: 'private',
    path: '/agenda-seguimiento-vacaciones',
    roles: ['administrador', 'empleado', 'jefe'],
    component: EmployeesTimeLines,
    exact: true,
  },
  {
    type: 'private',
    path: '/solicitud-vacaciones-empleado/:username',
    roles: ['administrador', 'empleado', 'jefe'],
    component: VacationRequest,
    exact: true,
  },
  {
    type: 'private',
    path: '/solicitudes-vacaciones',
    roles: ['administrador', 'jefe'],
    component: RequestsTimeLines,
    exact: true,
  },
];

export default router;